import { render } from "./myPoint.vue?vue&type=template&id=aba5b3ee"
import script from "./myPoint.vue?vue&type=script&lang=js"
export * from "./myPoint.vue?vue&type=script&lang=js"

import "./myPoint.vue?vue&type=style&index=0&id=aba5b3ee&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__